import React from 'react';
import { View } from 'react-native';
import { Loader } from '../../Loader';

export type LoadingContentOwnProps = {};

export type LoadingContentProps = LoadingContentOwnProps;

const LoadingContent: React.FC<LoadingContentProps> = (_props) => {
    return (
        <View style={{ flex: 1, alignSelf: 'stretch' }}>
            <Loader />
        </View>
    );
};

export default React.memo(LoadingContent);
